import ResourceManager from "./ResourceManager";

const CLIENTS_RESOURCE = {
  key: "clients",
  label: "Client",
  route: "clients",
  entity: "clients",
  titleField: "name",
  fields: [
    { name: "name", label: "Client Name", type: "text" },
    { name: "logo_url", label: "Logo (upload)", type: "image" },
    { name: "category", label: "Category (Government / PSU / Municipal / Development Agency / Educational Institution)", type: "text" },
    { name: "website_url", label: "Website URL (optional)", type: "text" },
    { name: "order", label: "Order (lower = shown first)", type: "number" },
    { name: "status", label: "Status (Draft / Published)", type: "status" },
    { name: "is_active", label: "Active", type: "boolean" },
  ],
};

export default function AdminClients() {
  return <ResourceManager resource={CLIENTS_RESOURCE} />;
}
